import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'
import { compose } from 'redux'

import { fetchToolAccessConditions } from 'clickNgo/entities/contactFlag/api'
import { fetchPartnerRefIDs } from 'clickNgo/entities/partner/api/fetchPartnerRefIDs'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

import { applyOrderManagementConditions } from './applyOrderManagementConditions'
import { applyToolAccessConditions } from './applyToolAccessConditions'
import { sortByComment } from './sortByComment'

interface IHandleFetchToolAccessConditionsParams {
  type: ProfilingCodeType
  partnerId: string
  profilingCodeList: IProfilingCode[]
  isHQ: boolean
}

export const handleFetchToolAccessConditions = async ({
  type,
  partnerId,
  profilingCodeList,
  isHQ,
}: IHandleFetchToolAccessConditionsParams) => {
  if (type === ProfilingCodeType.Tools) {
    const hasOSS = profilingCodeList.some((it) => it.code === 'OSS')
    const shouldFetchAdditionalInfo = hasOSS && isHQ

    const [toolAccessConditions, orderManagementList] = await Promise.all([
      fetchToolAccessConditions(partnerId),
      fetchPartnerRefIDs(
        {
          partnerId,
          shouldFetch: shouldFetchAdditionalInfo,
        },
        {
          isForce: true,
        }
      ),
    ])

    const toolAccessConditionsFn = applyToolAccessConditions({
      isHQ,
      toolAccessConditions,
    })

    const orderManagementConditionsFn = applyOrderManagementConditions({
      isHQ: shouldFetchAdditionalInfo,
      orderManagementList,
    })

    return compose(
      sortByComment,
      orderManagementConditionsFn,
      toolAccessConditionsFn
    )(profilingCodeList)
  }

  return profilingCodeList
}
